import React, { useEffect, useState } from "react";
import CryptoJS from "crypto-js";

import Modal from "../../../components/modal";
import { ErrorMessage } from "../../../components/errorMessage";
import ButtonComponent from "../../../components/button";
import { Radio } from "antd";
import api from "../../../services/api";

const TopupModal = ({
  show,
  title,
  onCancel,
  type,
  subscriptionAmount,
  subObj,
}) => {
  const [amount, setAmount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [redirecting, setRedirecting] = useState(false);
  const [transactionTypeId, setTransactionTypeId] = useState("3");

  const [authToken, setAuthToken] = useState(null);
  const [requestHash, setRequestHash] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [apiRefNumber, setApiRefNumber] = useState(null);

  const [taxCalculation, setTaxCalculation] = useState({
    originalAmount: 0,
    taxAmount: 0,
    finalAmount: 0,
  });

  const BANK_CONFIG = {
    KEY1: process.env.REACT_APP_ALFA_KEY_1,
    KEY2: process.env.REACT_APP_ALFA_KEY_2,
    CHANNEL_ID: process.env.REACT_APP_ALFA_CHANNEL_ID,
    MERCHANT_ID: process.env.REACT_APP_ALFA_MERCHANT_ID,
    STORE_ID: process.env.REACT_APP_ALFA_STORE_ID,
    MERCHANT_HASH: process.env.REACT_APP_ALFA_MERCHANT_HASH,
    MERCHANT_USERNAME: process.env.REACT_APP_ALFA_MERCHANT_USERNAME,
    MERCHANT_PASSWORD: process.env.REACT_APP_ALFA_MERCHANT_PASSWORD,
    RETURN_URL: process.env.REACT_APP_ALFA_RETURN_URL,
    SANDBOX_URL: process.env.REACT_APP_ALFA_SANDBOX_URL,
    IS_REDIRECTION_REQUEST: 0,
    TRANSACTION_TYPE_ID: transactionTypeId,
    CURRENCY: "PKR",
    IS_BIN: 0,
  };

  const encryptData = (data) => {
    try {
      const key = CryptoJS.enc.Utf8.parse(BANK_CONFIG.KEY1);
      const iv = CryptoJS.enc.Utf8.parse(BANK_CONFIG.KEY2);

      const encrypted = CryptoJS.AES.encrypt(data, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });

      return encrypted.toString();
    } catch (error) {
      console.error("Encryption error:", error);
      setErrorMessage("Error encrypting payment data");
      return null;
    }
  };

  const initiateHandshake = async () => {
    setLoading(true);
    setErrorMessage(null);

    if (type !== "SUBSCRIPTION" && amount < 10) {
      setErrorMessage("Minimum 10 Rs is required");
      setLoading(false);
      return;
    }

    try {
      const transactionRef = Math.floor(Math.random() * 1786612).toString();
      setApiRefNumber(transactionRef);

      const response = await api.post("/payments/accessToken", {
        TransactionAmount: taxCalculation.finalAmount,
        transactionTypeId: transactionTypeId,
      });

      if (response.data?.data) {
        const { HS_TransactionReferenceNumber, authToken } = response.data.data;

        setAuthToken(authToken);
        setApiRefNumber(HS_TransactionReferenceNumber);
        generateSSOHash(authToken, HS_TransactionReferenceNumber);
      } else {
        throw new Error("Invalid response from payment gateway");
      }
    } catch (error) {
      console.error("Payment initialization error:", error);
      setErrorMessage(
        "Failed to initialize payment: " + (error.message || "Unknown error")
      );
      setLoading(false);
    }
  };

  const calculateFlatTax = (enteredAmount) => {
    const original = parseFloat(enteredAmount) || 0;
    const taxRate = 0.21;
    const taxAmount = original * taxRate;
    const final = original - taxAmount;

    return {
      originalAmount: original,
      taxAmount: parseFloat(taxAmount.toFixed(2)),
      finalAmount: parseFloat(final.toFixed(2)),
    };
  };

  const handleAmountChange = (e) => {
    const newAmount = e.target.value;
    setAmount(newAmount);

    const taxCalc = calculateFlatTax(newAmount);
    setTaxCalculation(taxCalc);

    if (newAmount >= 10) {
      setErrorMessage(null);
    } else if (newAmount !== "") {
      setErrorMessage("Minimum 10 Rs is required");
    }
  };

  const generateSSOHash = (token, transactionRef) => {
    try {
      let initialRequestHash1 = null;

      const mapStringSSO =
        `AuthToken=${token}` +
        `&RequestHash=${initialRequestHash1}` +
        `&ChannelId=${BANK_CONFIG.CHANNEL_ID}` +
        `&Currency=${BANK_CONFIG.CURRENCY}` +
        `&IsBIN=${BANK_CONFIG.IS_BIN}` +
        `&ReturnURL=${BANK_CONFIG.RETURN_URL}` +
        `&MerchantId=${BANK_CONFIG.MERCHANT_ID}` +
        `&StoreId=${BANK_CONFIG.STORE_ID}` +
        `&MerchantHash=${BANK_CONFIG.MERCHANT_HASH}` +
        `&MerchantUsername=${BANK_CONFIG.MERCHANT_USERNAME}` +
        `&MerchantPassword=${BANK_CONFIG.MERCHANT_PASSWORD}` +
        `&TransactionTypeId=${BANK_CONFIG.TRANSACTION_TYPE_ID}` +
        `&TransactionReferenceNumber=${transactionRef}` +
        `&TransactionAmount=${
          type === "SUBSCRIPTION"
            ? subscriptionAmount
            : taxCalculation.originalAmount
        }`;

      const ssoHash = encryptData(mapStringSSO);

      if (!ssoHash) throw new Error("Failed to encrypt SSO data");

      setRequestHash(ssoHash);
      setLoading(false);
    } catch (error) {
      console.error("SSO hash generation error:", error);
      setErrorMessage(
        "Failed to generate payment request: " +
          (error.message || "Unknown error")
      );
      setLoading(false);
    }
  };

  useEffect(() => {
    if (authToken && requestHash && apiRefNumber) {
      setRedirecting(true);
      const form = document.getElementById("BankAlfalahPaymentForm");

      if (form) {
        const values = Array.from(form.elements)
          .filter((el) => el.name) // ignore elements without a name
          .reduce((acc, el) => {
            acc[el.name] = el.value;
            return acc;
          }, {});

        // save payment session in localstorage
        if (type === "SUBSCRIPTION") {
          localStorage.removeItem("sessionTopup");
          localStorage.setItem("sessionSub", JSON.stringify(subObj));
          debugger;
        } else {
          localStorage.removeItem("sessionSub", subObj);
          localStorage.setItem(
            "sessionTopup",
            JSON.stringify({ type: "TOPUP" })
          );
        }
        debugger;

        // Submit after logging
        setTimeout(() => form.submit(), 1000);
      }
    }
  }, [authToken, requestHash, apiRefNumber, subObj, type]);

  return (
    <Modal show={show} title={title} onCancel={onCancel}>
      <div>
        <div className="mb-2">
          <label className="fw-bold mb-1 d-block">Payment method</label>
          <div className="mt-2">
            <Radio.Group
              options={[
                { label: "Credit/Debit card", value: "3" },
                { label: "JazzCash", value: "11" },
              ]}
              defaultValue="3"
              onChange={(e) => setTransactionTypeId(e.target.value)}
              style={{ display: "flex" }}
            />
          </div>
        </div>
        {type !== "SUBSCRIPTION" && (
          <div className="mb-3">
            <label htmlFor="amount" className="fw-bold mb-1">
              Enter Amount
            </label>
            <input
              type="number"
              className="d-block fw-bold border-2 text-black-50 w-100 bg-transparent p-2"
              id="amount"
              value={amount}
              onChange={handleAmountChange}
              min="10"
            />
          </div>
        )}

        {type !== "SUBSCRIPTION" ? (
          <div className="border p-3 mb-3 rounded">
            <h6 className="fw-bold mb-2">Summary</h6>
            <div className="d-flex justify-content-between mb-2">
              <span>Original Amount:</span>
              <span>Rs. {taxCalculation.originalAmount.toFixed(2)}</span>
            </div>
            <div className="d-flex justify-content-between mb-2 text-secondary">
              <span>Tax Deducted :</span>
              <span>- Rs. {taxCalculation.taxAmount.toFixed(2)}</span>
            </div>
            <div className="d-flex justify-content-between fw-bold mt-2 pt-2 border-top">
              <span>Subtotal:</span>
              <span>Rs. {taxCalculation.finalAmount.toFixed(2)}</span>
            </div>
          </div>
        ) : (
          <div className="border p-3 mb-3 rounded">
            <h6 className="fw-bold mb-2">Summary</h6>
            <div className="d-flex justify-content-between fw-bold mt-2 pt-2 border-top">
              <span>Subtotal:</span>
              <span>
                {/* {console.log("subscriptionAmount", subscriptionAmount)} */}
                Rs.{" "}
                {subscriptionAmount && Number(subscriptionAmount).toFixed(2)}
              </span>
            </div>
          </div>
        )}

        <ErrorMessage message={errorMessage} />

        <div className="mt-3 d-flex justify-content-end align-items-center gap-2">
          <ButtonComponent
            onClick={initiateHandshake}
            disabled={loading}
            type="primary"
          >
            {loading
              ? "Processing..."
              : redirecting
              ? "Redirecting..."
              : "Proceed"}
          </ButtonComponent>
        </div>

        {authToken && requestHash && (
          <form
            action={`${process.env.REACT_APP_ALFA_FORM_POST_URL}`}
            id="BankAlfalahPaymentForm"
            method="post"
            noValidate
          >
            <input name="AuthToken" type="hidden" value={authToken} />
            <input name="RequestHash" type="hidden" value={requestHash} />
            <input
              name="ChannelId"
              type="hidden"
              value={BANK_CONFIG.CHANNEL_ID}
            />
            <input name="Currency" type="hidden" value={BANK_CONFIG.CURRENCY} />
            <input name="IsBIN" type="hidden" value={BANK_CONFIG.IS_BIN} />
            <input
              name="ReturnURL"
              type="hidden"
              value={BANK_CONFIG.RETURN_URL}
            />
            <input
              name="MerchantId"
              type="hidden"
              value={BANK_CONFIG.MERCHANT_ID}
            />
            <input name="StoreId" type="hidden" value={BANK_CONFIG.STORE_ID} />
            <input
              name="MerchantHash"
              type="hidden"
              value={BANK_CONFIG.MERCHANT_HASH}
            />
            <input
              name="MerchantUsername"
              type="hidden"
              value={BANK_CONFIG.MERCHANT_USERNAME}
            />
            <input
              name="MerchantPassword"
              type="hidden"
              value={BANK_CONFIG.MERCHANT_PASSWORD}
            />
            <input
              name="TransactionTypeId"
              type="hidden"
              value={BANK_CONFIG.TRANSACTION_TYPE_ID}
            />
            <input
              name="TransactionReferenceNumber"
              type="hidden"
              value={apiRefNumber}
            />
            <input
              name="TransactionAmount"
              type="hidden"
              value={
                type === "SUBSCRIPTION"
                  ? subscriptionAmount
                  : taxCalculation.originalAmount
              }
            />
          </form>
        )}
      </div>
    </Modal>
  );
};

export default TopupModal;
